// TODO: Add pay conversion tracking
// TODO: it currently creates 2 Stripe sessions.
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import Player from "../../Components/PlayerNew";
import store from "./store";
import userStore from "../../Stores/User";
import "./index.scss";
// import LockIcon from "@material-ui/icons/Lock";
// import AccountCircleIcon from "@material-ui/icons/AccountCircle";
// import CancelIcon from "@material-ui/icons/Cancel";
import {
  Lock as LockIcon,
  AccountCircle as AccountCircleIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import { isUserSubscribedToDrawabox } from "../../audiblogsApi";
import mixpanel from "mixpanel-browser";
import loadingIcon from "../../Assets/loading.gif";
import { isSafari } from "react-device-detect";

const Embed = observer(() => {
  let currentArticle = store.currentArticle;
  const [isFullPlayer, setIsFullPlayer] = useState(false);
  const [isPaidArticle, setIsPaidArticle] = useState(null);
  const [isUserSubscribed, setIsUserSubscribed] = useState(null);
  const { isSignedIn, idToken, user } = userStore;
  const [isFinishedChecking, setIsFinishedChecking] = useState(false);

  const getArticleUrl = () => {
    if (currentArticle.article_url) {
      return currentArticle.article_url;
    } else if (currentArticle.article_id) {
      return currentArticle.article_id;
    } else {
      return null;
    }
  };

  const checkIsPaidArticle = () => {
    let currentArticleUrl;
    if (getArticleUrl()) {
      currentArticleUrl = getArticleUrl();
    } else {
      return false;
    }
    const freeArticleUrls = [
      "drawabox.com/lesson/0",
      "drawabox.com/lesson/0/1",
      "drawabox.com/lesson/0/2",
      "drawabox.com/lesson/0/3",
      "drawabox.com/lesson/0/4",
      "drawabox.com/lesson/0/5",
      "drawabox.com/lesson/1",
      "drawabox.com/lesson/1/1",
      "drawabox.com/lesson/1/2",
      "drawabox.com/lesson/1/3",
      "drawabox.com/lesson/1/4",
      "thecodegnomes.com/dabdev/lesson/0",
      "thecodegnomes.com/dabdev/lesson/0/1",
      "thecodegnomes.com/dabdev/lesson/0/2",
      "thecodegnomes.com/dabdev/lesson/0/3",
      "thecodegnomes.com/dabdev/lesson/0/4",
      "thecodegnomes.com/dabdev/lesson/0/5",
      "thecodegnomes.com/dabdev/lesson/1",
      "thecodegnomes.com/dabdev/lesson/1/1",
      "thecodegnomes.com/dabdev/lesson/1/2",
      "thecodegnomes.com/dabdev/lesson/1/3",
      "thecodegnomes.com/dabdev/lesson/1/4",
    ];

    // 1. Check if this is a drawabox article.
    if (
      currentArticleUrl.includes("drawabox.com") ||
      currentArticleUrl.includes("thecodegnomes.com")
    ) {
      if (
        !freeArticleUrls.some(
          (freeArticleUrl) => currentArticleUrl === freeArticleUrl
        )
      ) {
        setIsPaidArticle(true);
        console.log(currentArticleUrl, " is a premium article");
        return true;
      } else {
        setIsPaidArticle(false);
        console.log(currentArticleUrl, " is a free article");
        return false;
      }
    }
    return false;
  };

  const updateIsFullPlayer = (isFullPlayer) => {
    setIsFullPlayer(isFullPlayer);
    if (isFullPlayer) {
      store.onMaximizePlayer();
    } else {
      store.onMinimizePlayer();
    }
  };

  useEffect(() => {
    // Turn isFinishedChecking `true` once it's done checking
    // if it's a paid article or not, if user is paying or not, etc.
    // Until it's done, it'll show a loading icon.
    if (isPaidArticle === true) {
      console.log("isPaidArticle === true");
      if (isSignedIn !== null && isUserSubscribed !== null) {
        setIsFinishedChecking(true);
      } else if (isSignedIn === false) {
        setIsFinishedChecking(true);
      } else {
        console.log(
          "setIsFinishedChecking(false)",
          isSignedIn,
          isUserSubscribed
        );
      }
    } else if (isPaidArticle === false) {
      setIsFinishedChecking(true);
    }
  }, [isSignedIn, isPaidArticle, isUserSubscribed]);

  useEffect(() => {
    if (currentArticle) {
      checkIsPaidArticle();
    } else {
      if (window.location.href.includes("localhost")) {
        currentArticle = {
          article_url: "drawabox.com/lesson/1/4",
          audio_url:
            "https://s3.us-east-1.amazonaws.com/audiblogs-conversions-new/publishers/drawabox/lesson-2-1.088a332c-117f-40be-8fff-bf0cbafb9c93.mp3",
          title: "You're on localhost",
        };
        checkIsPaidArticle();
      }
    }
  }, [currentArticle]);

  useEffect(() => {
    if (user) {
      if (user.subscribed_to_drawabox) {
        setIsUserSubscribed(true);
      } else {
        setIsUserSubscribed(false);
      }
    }
  }, [user]);

  useEffect(() => {
    window.addEventListener("message", store.listenForCommandMessages);
    store.notifyParentWindowReady();

    return () => {
      window.removeEventListener("message", store.listenForCommandMessages);
    };
  }, []);

  // isPaidArticle && isUserSubscribed === null
  // TODO: in addition to isPaidArticle, need to check if logged in, etc.
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      {!isFinishedChecking ? (
        <div className="player-common">
          <img className="loading-ico" src={loadingIcon} alt="loading..."></img>
        </div>
      ) : isPaidArticle && !isUserSubscribed ? (
        <div className="player-common">
          <div className="explanation-cta" style={{}}>
            <div className="subscription" style={{ marginTop: "18px" }}>
              <a href="/signin?redirected_from=drawabox" target="_blank">
                <div className="ico-span-container">
                  <LockIcon className="icon" />
                  <span className="span">Access for $2.99/mo</span>
                </div>
              </a>
            </div>
            <div className="explanation" style={{ textAlign: "center" }}>
              <a
                href="https://drawabox.com/lesson/0/1"
                target="_blank"
                rel="nonreferrer"
              >
                Try Lesson 0 for free
              </a>
              <div style={{ fontSize: "13px", opacity: "0.7" }}>
                Issues? Try a different browser
              </div>
            </div>
          </div>
          <div className="login" style={{ display: isSignedIn && "none" }}>
            <a
              href="/signin?redirected_from=drawabox"
              target="_blank"
              rel="nonreferrer"
            >
              <div className="ico-span-container">
                <AccountCircleIcon className="icon-small" />
                <span className="span-small">Login</span>
              </div>
            </a>
          </div>
          <div
            className="close-button-cta"
            onClick={(e) => {
              store.onDisablePlayer();
            }}
          >
            <CancelIcon /> Close
          </div>
        </div>
      ) : (
        <Player
          {...{
            updateIsFullPlayer,
            isFullPlayer,
            currentArticle: store.currentArticle,
            onPreviousArticle: store.onPreviousArticle,
            onNextArticle: store.onNextArticle,
            onDisablePlayer: store.onDisablePlayer,
            listeningWhere: "/embed",
            autoPlay: false,
            fullPlayerLeaveSpace: 0,
          }}
        />
      )}
    </div>
  );
});

export default Embed;
